const collapses = document.querySelectorAll(".collapsible");
collapses.forEach((item)=>item.addEventListener("click", function() {
        this.classList.toggle("collapsible--expanded");
    }));

//# sourceMappingURL=index.1384c44c.js.map
